import { useQuery } from '@tanstack/react-query'
import {
  fetchAllPendingOpeningEvents,
  fetchConfigDoor,
  fetchPendingOpeningEvents,
  fetchStoreOpeningState,
} from '../queries/door.queries'

export const useConfigDoor = (storeId: number) =>
  useQuery({
    queryKey: ['doorConfig', storeId],
    queryFn: () => fetchConfigDoor(storeId),
  })

export const useStoreOpeningState = (storeId: number) =>
  useQuery({
    queryKey: ['storeOpeningState', storeId],
    queryFn: () => fetchStoreOpeningState(storeId),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 25_000,
  })

export const usePendingOpeningEvents = (storeId: number) =>
  useQuery({
    queryKey: ['pendingOpeningEvents', storeId],
    queryFn: () => fetchPendingOpeningEvents(storeId),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

export const useAllPendingOpeningEvents = () =>
  useQuery({
    queryKey: ['pendingOpeningEvents', 'all'],
    queryFn: () => fetchAllPendingOpeningEvents(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

export const usePendingOpeningEventsForStores = (
  storeIds: number[],
  refetchInterval: number | false = false,
) => {
  const normalizedStoreIds = [
    ...new Set(storeIds.filter((storeId) => Number.isSafeInteger(storeId) && storeId > 0)),
  ]
    .sort((left, right) => left - right)
    .slice(0, 100)
  return useQuery({
    queryKey: ['pendingOpeningEvents', 'stores', normalizedStoreIds],
    queryFn: () =>
      normalizedStoreIds.length > 0
        ? fetchAllPendingOpeningEvents(normalizedStoreIds)
        : Promise.resolve([]),
    refetchInterval,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })
}
